import React from "react";

const EventPill = ({ event, screenSize, language, t, onEventClick }) => {
  return (
    <button
      type="button"
      className="event-pill"
      style={{
        border: "none",
        outline: "none",
        background: `linear-gradient(90deg, ${event.color}CC 60%, ${event.color}99 100%)`,
        borderRadius: "999px",
        boxShadow: `0 2px 12px 0 ${event.color}33`,
        padding: screenSize.isMobile ? "4px 8px" : "8px 18px",
        fontSize: screenSize.isMobile ? "10px" : "13px",
        fontWeight: 700,
        minHeight: screenSize.isMobile ? "20px" : "32px",
        display: "flex",
        alignItems: "center",
        gap: screenSize.isMobile ? "4px" : "8px",
        transition: "all 0.18s cubic-bezier(0.25,0.46,0.45,0.94)",
        cursor: "pointer",
        marginBottom: screenSize.isMobile ? "2px" : "6px",
        marginTop: "2px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        color: "#fff",
      }}
      onClick={(e) => {
        e.stopPropagation();
        onEventClick(event);
      }}
      aria-label={`${t.viewEvent} ${event.title}`}
      aria-haspopup="dialog"
      onMouseEnter={(e) =>
        (e.currentTarget.style.filter =
          "brightness(1.08) drop-shadow(0 2px 8px #0002)")
      }
      onMouseLeave={(e) => (e.currentTarget.style.filter = "")}
    >
      <span
        style={{
          display: "inline-block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: screenSize.isMobile ? "80px" : "120px",
          verticalAlign: "middle",
        }}
      >
        {event.title.length > (screenSize.isMobile ? 15 : 20)
          ? event.title.substring(0, screenSize.isMobile ? 15 : 20) + "..."
          : event.title}
      </span>
    </button>
  );
};

export default EventPill;
